import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

const onboardingCards = [
  {
    title: "We don't predict your future.",
    subtitle: "We identify repeating patterns in your life that you can understand and adjust."
  },
  {
    title: "Patterns to understand, not destiny to accept.",
    subtitle: "Use ancient wisdom as an analytical framework, not absolute truth."
  },
  {
    title: "You decide what to fix.",
    subtitle: "Get empowering insights and practical remedies based on your unique energy signature."
  }
];

function Onboarding({ onComplete }) {
  const [currentCard, setCurrentCard] = useState(0);
  const navigate = useNavigate();

  const handleNext = () => {
    if (currentCard < onboardingCards.length - 1) {
      setCurrentCard(currentCard + 1);
    } else {
      onComplete();
      navigate('/auth');
    }
  };

  const handleSkip = () => {
    onComplete();
    navigate('/auth');
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      padding: '2rem',
      background: '#0A0F2A'
    }}>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '2rem' }}>
        <button
          onClick={handleSkip}
          className="btn btn-ghost"
          data-testid="skip-onboarding"
        >
          Skip
        </button>
      </div>

      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <AnimatePresence mode="wait">
          <motion.div
            key={currentCard}
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -50 }}
            transition={{ duration: 0.3 }}
            style={{
              background: '#151827',
              border: '1px solid #2D3748',
              borderRadius: '24px',
              padding: '3rem',
              maxWidth: '600px',
              textAlign: 'center'
            }}
          >
            <h2 style={{
              fontSize: '2rem',
              marginBottom: '1.5rem',
              color: '#F9FAFB'
            }}>
              {onboardingCards[currentCard].title}
            </h2>
            <p style={{
              fontSize: '1.125rem',
              color: '#D1D5DB',
              lineHeight: 1.6
            }}>
              {onboardingCards[currentCard].subtitle}
            </p>
          </motion.div>
        </AnimatePresence>
      </div>

      <div style={{ display: 'flex', justifyContent: 'center', gap: '0.5rem', marginBottom: '2rem' }}>
        {onboardingCards.map((_, index) => (
          <div
            key={index}
            style={{
              width: '8px',
              height: '8px',
              borderRadius: '50%',
              background: index === currentCard ? '#00D9FF' : '#374151',
              transition: 'all 0.2s'
            }}
          />
        ))}
      </div>

      <button
        onClick={handleNext}
        className="btn btn-primary"
        data-testid="next-onboarding"
        style={{ maxWidth: '400px', margin: '0 auto', width: '100%' }}
      >
        {currentCard === onboardingCards.length - 1 ? "Get Started" : "Next"}
      </button>
    </div>
  );
}

export default Onboarding;